

























































































































import Vue from "vue";
import { Component } from "vue-property-decorator";
import "@/styles/Login.scss";
import { Services } from "../services/user-service";
import AuthService from "../services/auth-service";
import facebookLogin from "facebook-login-vuejs";
import "@/styles/loading.scss";
import config from "../services/api-config";
import { TheMask } from "vue-the-mask";
import { GeneralService } from "../services/general-service";
import ExAuthService from "../services/AuthService";
import TokenWebsite from "../services/tokan-service";

@Component({
  components: {
    facebookLogin,
    TheMask,
  },
})
export default class Login extends Vue {
  components: {
    facebookLogin;
  };

  private auth = new AuthService();
  private externalAuth = new ExAuthService();

  private service = new GeneralService();
  private tokanService = new TokenWebsite();

  private username = "";
  private password = "";
  public errorMessage = "";
  private personalID;
  private email;
  private name;
  private isConnected;
  private isError = false;
  private apiLoading = false;
  private error = "";
  private isPre = false;
  private isPre2Batch = false;
  private allowLogout = false;

  private form = {
    username: "",
    cnic: "",
  };

  goToTest() {
    this.$router.push("testclassselect");
  }

  login() {
    if (this.username && this.password) {
      this.auth.login(this.username, this.password);
    }
  }

  logoutAuth() {
    this.externalAuth.logout();
  }

  goToDefault() {
    document.location.reload();
    this.$router.push("/selectApp");
  }

  goToPre() {
    document.location.reload();
    localStorage[config.isPre] = true;
    this.$router.push("/pre-module");
  }

  async getUserData(fb) {
    return await fb.FB.api(
      "/me",
      "GET",
      { fields: "id, name, email" },
      (userInformation) => {
        if (userInformation.error) {
          localStorage[config.fbLogin] = "error";
        } else {
          localStorage[config.fbLogin] = JSON.stringify(userInformation);
          localStorage[config.username] = userInformation.name;
          this.auth.login("facebook", "facebook");
        }
      }
    );
  }

  private resetModal() {
    this.$bvModal.show("reset");
  }

  private resetPassword() {
    this.apiLoading = true;
    this.service
      .resetPassword(this.form.username, this.form.cnic)
      .then((response) => {
        this.apiLoading = false;
        if (response.password) {
          this.error = "Your newly generated password is " + response.password;
        } else {
          this.error =
            "Dear student. Seems like you are facing an issue logging in. Kindly call on 080078608 to get your issue resolved promptly.";
        }
      })
      .catch((err) => {
        this.apiLoading = false;
        this.error =
          "Dear student. Seems like you are facing an issue logging in. Kindly call on 080078608 to get your issue resolved promptly.";
      });
  }

  sdkLoaded(payload) {
    this.isConnected = payload.isConnected;
    this.$store.state.fb = payload.FB;
  }

  async onLogin(payload) {
    if (payload.response.status == "connected") {
      this.getUserData(payload);
    }
  }

  private checkPre() {
    let matchedNode = this.username.match(/(\d+)/);
    if (
      this.username &&
      matchedNode &&
      matchedNode[0] &&
      matchedNode[0][0] == "2"
    ) {
      this.isPre = true;
      if (matchedNode[0][1] == "0" && matchedNode[0][2] == "9") {
        this.isPre2Batch = true;
      } else {
        this.isPre2Batch = false;
      }
    } else {
      this.isPre = false;
      this.isPre2Batch = false;
    }
  }

  onLogout() {
    this.isConnected = false;
    localStorage[config.fbLogin] = undefined;
  }

  async externalLogin() {
    let response = await this.externalAuth.login();
    let resp = await this.auth.loginExternal(response);
    this.tokanService.gettokenwebsite().then((result) => {
      const jwtResponse = result.result.access_token;
      if (jwtResponse) {
        localStorage.setItem("jwtToken", jwtResponse);
        localStorage.setItem('jwtTokenTime', new Date().toISOString());
      }

      if (resp == "isprof") {
        this.$bvModal.show("prof-option");
      }

      if (resp == "failed") {
        this.errorMessage =
          "Something went wrong. Kindly contact our helpline on 080078608 or lodge a complaint on complaint.pgc.edu.pk";
      } else if (resp == "not auth") {
        this.errorMessage =
          "Please complete the Microsoft Authentication process to login";
      } else if (resp == "not registered") {
        this.errorMessage =
          "Your account is not registered in PGC E-learn. Kindly contact our helpline at 0800-78608";
        this.allowLogout = true;
      } else if (resp == "not exist") {
        this.errorMessage = "This user is not registered";
      } else {
        window.location.reload();
      }
    });
  }

  async pgcLogin() {
    const button = document.getElementById("login-button");
    const error = document.getElementsByClassName("error")[0];
    if (this.username && this.password) {
      if (this.username.indexOf("@pgc.edu.pk") < 0) {
        this.username += "@pgc.edu.pk";
      }

      if (button) {
        button.classList.add("running");
      }

      let response = await this.auth.loginDirect(this.username, this.password);

      if (response == "isprof") {
        this.$bvModal.show("prof-option");
      }

      if (response == "failed" && error !== null) {
        if (button) {
          button.classList.remove("running");
        }
        this.errorMessage =
          "Incorrect password. Kindly contact our helpline on 080078608";
        error.classList.remove("error-visible");
        setTimeout(function () {
          error.classList.add("error-visible");
        }, 200);
      } else {
        this.errorMessage = "";
      }
    } else {
      this.errorMessage = "Please enter your Username and Password";
      error.classList.remove("error-visible");
      setTimeout(function () {
        error.classList.add("error-visible");
      }, 200);
    }
  }
}
